import React, { useEffect, useMemo, useRef } from 'react';
import { Container, Sprite } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import { Spine } from '../../../core/classes/spine';
import { isMobile } from '../../../core/helpers/isMobile';
import { getGameImages } from '../../../core/helpers/getGameImages';

const GameBoard = observer(({ containerConfig }) => {
  const boardContainerRef = useRef(null);

  const { gameBoard } = useMemo(() => {
    return getGameImages();
  }, []);

  useEffect(() => {
    if (!isMobile()) {
      const board = new Spine({ key: 'board' });
      board.play('frameShine', true);
      boardContainerRef.current.addChild(board);
    }
  }, [boardContainerRef]);

  return (
    <Container name='GameBoardWrapper'>
      {!isMobile() ? (
        <Container ref={boardContainerRef} {...containerConfig} name='GameBoardContainer' />
      ) : (
        <Container {...containerConfig} name='GameBoardContainer'>
          <Sprite anchor={0.5} x={!isMobile() && 403} texture={gameBoard} />
        </Container>
      )}
    </Container>
  );
});

export default GameBoard;
